/* Upside welcome popup (replaces Alia) · B2C web
 * Simon 2026-10-07: same look as the Alia popup, our own code, A/B test.
 *   Simon 2026-10-08: scratch card removed (Alia's "Scratch off" had the worst buyers, 18%).
 *   A = Alia's best, "Control (6s)": "Exclusive Discount" Claim -> quiz (30s timer) -> email -> code.
 *   B = Alia's runner-up wording, "Mystery Discount": same steps and timer, mystery copy.
 *   C = Alia's "10% OFF (B)" wording: plain offer, no mystery. Same steps and timer.
 *   All open at 6s; each visitor gets one variant (1/3 each), kept on later visits.
 * Backend: worker upside-popup (Klaviyo Newsletter list + same alia_* fields, Shopify customer tags,
 * D1 events, /stats dashboard). Off for the public until the worker /config says live:true;
 * ?udpop=1 forces it on for testing (?udpop=A / ?udpop=B picks the variant, ?udpop=0 clears).
 * Not loaded for logged-in customers (theme.liquid).
 */
(function () {
  'use strict';
  var API = 'https://upside-popup.gilles-577.workers.dev';
  var HERO = window.UD_POPUP_HERO || '';
  var LOGO = 'https://upsidedrinks.ca/cdn/shop/files/upside_LOGO_800_x_400_px_2.png?v=1696776927&width=280';
  var LS = 'ud-pop:';
  var CLOSE_DAYS = 3;

  function get(k) { try { return localStorage.getItem(LS + k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(LS + k, v); } catch (e) {} }
  function del(k) { try { localStorage.removeItem(LS + k); } catch (e) {} }

  var lang = ((document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0) ? 'fr' : 'en';
  var dev = window.matchMedia('(max-width:767px)').matches ? 'm' : 'd';
  var T = {
    en: {
      got1: "You've Got An", got2: 'Exclusive', got3: 'Discount!', claim: 'Claim',
      gotLine: "You've Got An Exclusive Discount!", q: 'What would you like to discover?',
      a: ['🍷 Non-alc Wines', '🥃 Non-alc Spirits', '🍺 Non-alc Beers', '🍹 Mocktails'], // Simon 2026-10-08: 4 answers, spirits and mocktails apart
      m1: "You've Unlocked A", m2: 'Mystery', m3: 'Discount!', mLine: 'Your Mystery Discount Is Waiting!',
      mWhere: 'Where should we send your mystery discount?', noThanks: 'No thanks',
      c1: 'Get', c2: '10% Off', c3: 'your first order', cLine: 'Get 10% Off Your First Order', cWhere: 'Where should we send your 10% off code?',
      where: 'Where should we send your exclusive discount?', email: 'Your email address', reveal: 'Reveal Discount',
      bad: 'Please enter a valid email.', err: 'Something went wrong. Try again.',
      done: 'Your discount is ready!', memberH: "You're already on our list!", memberP: 'Your code still works on your first order:',
      backH: 'Welcome back!', backP: 'The 10% welcome offer is for first orders. Come see what is new.', backBtn: "Shop what's new", off: '10% OFF', applied: 'Applied at checkout with this code:', copy: 'Copy', copied: 'Copied!',
      shop: 'Shop now', teaser: '10% OFF', close: 'Close',
      smsH: 'Want an extra $5 off?', smsP: 'Add your phone and we’ll text you a $5 code.', phone: 'Mobile number',
      smsOk: 'Yes, text me deals and new arrivals from Upside Drinks. Up to 4 msgs/month. Msg & data rates may apply. Consent is not a condition of purchase. Reply STOP to opt out, HELP for help.',
      smsBtn: 'Text me my $5', smsBadPhone: 'Please enter a valid mobile number.', smsNeedOk: 'Please check the box to get texts.',
      smsSent: 'Your $5 code is on its way by text.', next: 'Continue', legal: 'By signing up you agree to receive emails from Upside Drinks. Unsubscribe anytime.'
    },
    fr: {
      got1: 'Vous avez un', got2: 'rabais', got3: 'exclusif!', claim: 'Réclamer',
      gotLine: 'Vous avez un rabais exclusif!', q: 'Qu’aimeriez-vous découvrir?',
      a: ['🍷 Vins sans alcool', '🥃 Spiritueux sans alcool', '🍺 Bières sans alcool', '🍹 Mocktails'],
      m1: 'Vous avez débloqué', m2: 'un rabais', m3: 'mystère!', mLine: 'Votre rabais mystère vous attend!',
      mWhere: 'Où devons-nous envoyer votre rabais mystère?', noThanks: 'Non, merci',
      c1: 'Obtenez', c2: '10 % de rabais', c3: 'sur votre première commande', cLine: 'Obtenez 10 % de rabais sur votre première commande', cWhere: 'Où devons-nous envoyer votre code de 10 %?',
      where: 'Où devons-nous envoyer votre rabais exclusif?', email: 'Votre adresse courriel', reveal: 'Découvrir l’offre',
      bad: 'Entrez une adresse courriel valide.', err: 'Une erreur est survenue. Réessayez.',
      done: 'Votre rabais est prêt!', memberH: 'Vous êtes déjà sur notre liste!', memberP: 'Votre code fonctionne toujours pour votre première commande :',
      backH: 'Bon retour!', backP: 'Le rabais de 10 % est réservé à la première commande. Découvrez les nouveautés.', backBtn: 'Voir les nouveautés', off: '10 % DE RABAIS', applied: 'Appliqué à la caisse avec ce code :', copy: 'Copier', copied: 'Copié!',
      shop: 'Magasiner', teaser: '10 % DE RABAIS', close: 'Fermer',
      smsH: 'Envie de 5 $ de rabais en plus?', smsP: 'Ajoutez votre cellulaire et on vous texte un code de 5 $.', phone: 'Numéro de cellulaire',
      smsOk: 'Oui, textez-moi les promos et nouveautés d’Upside Drinks. Jusqu’à 4 messages/mois. Des frais de messagerie et de données peuvent s’appliquer. Le consentement n’est pas une condition d’achat. Répondez STOP pour vous désabonner, AIDE pour de l’aide.',
      smsBtn: 'Textez-moi mon 5 $', smsBadPhone: 'Entrez un numéro de cellulaire valide.', smsNeedOk: 'Cochez la case pour recevoir les textos.',
      smsSent: 'Votre code de 5 $ s’en vient par texto.', next: 'Continuer', legal: 'En vous inscrivant, vous acceptez de recevoir des courriels d’Upside Drinks. Désabonnement en tout temps.'
    }
  }[lang];

  // ---------- URL test switches ----------
  var force = null;
  var textMode = false; // ?udtext=1 (email campaign link): open straight on the phone step, no 10% code
  try {
    var qp = new URLSearchParams(location.search).get('udpop');
    if (qp === '0') { ['force', 'var', 'closed', 'done'].forEach(del); }
    else if (qp) { set('force', '1'); del('closed'); del('done'); if (/^[ABC]$/.test(qp)) set('var', qp); }
    force = get('force') === '1';
    var qs = new URLSearchParams(location.search).get('udsms');
    if (qs === '1') set('fsms', '1'); else if (qs === '0') del('fsms');
    textMode = new URLSearchParams(location.search).get('udtext') === '1';
  } catch (e) {}
  var smsOn = false;

  // ---------- eligibility ----------
  var path = location.pathname;
  if (/^\/(fr\/)?(cart|account|checkouts?|pages\/ideas|pages\/ambassador|challenge)/.test(path)) return;
  if (get('done') === '1' && !textMode) return;
  function knownToKlaviyo() {
    // __kla_id carries $exchange_id / $email once Klaviyo knows the visitor (clicked an email, signed up before)
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return false;
      var o = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(o.$exchange_id || o.$email);
    } catch (e) { return false; }
  }

  var vid = get('vid');
  if (!vid) { vid = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10)); set('vid', vid); }
  var variant = get('var');

  // ---------- events ----------
  var queue = [], qTimer = null;
  function track(ev, detail) {
    queue.push({ vid: vid, var: variant, lang: lang, dev: dev, ev: ev, detail: detail || '', path: path });
    if (!qTimer) qTimer = setTimeout(flush, 600);
  }
  function flush() {
    qTimer = null;
    if (!queue.length) return;
    var body = JSON.stringify({ batch: queue.splice(0, 20) });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(API + '/e', new Blob([body], { type: 'text/plain' }));
      else fetch(API + '/e', { method: 'POST', body: body, keepalive: true });
    } catch (e) {}
  }
  window.addEventListener('pagehide', flush);

  // ---------- CSS ----------
  var BLUE = '#37446E', INK = '#202A36';
  var CSS = [
    '.udp{position:fixed;inset:0;z-index:2147483600;display:flex;background:#FDFDFD;font-family:Montserrat,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:' + INK + ';animation:udpIn .35s ease}',
    '@keyframes udpIn{from{opacity:0}to{opacity:1}}',
    '.udp *{box-sizing:border-box}',
    '.udp-left{flex:0 0 55%;display:flex;align-items:center;justify-content:center;padding:40px 32px;overflow-y:auto;position:relative;z-index:2}',
    '.udp-right{flex:1 1 auto;position:relative;overflow:hidden;background:#cfe3f7}',
    '.udp-right img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:78% 50%}',
    '.udp-wave{position:absolute;top:0;bottom:0;left:-1px;width:90px;height:100%;z-index:1}',
    '.udp-x{position:absolute;top:18px;left:18px;width:40px;height:40px;border:0;background:none;color:#6B7590;font-size:30px;line-height:1;cursor:pointer;z-index:5;border-radius:50%}',
    '.udp-x:hover{background:#EEF1F8;color:' + BLUE + '}',
    '.udp-in{width:100%;max-width:540px;text-align:center}',
    '.udp-logo{display:block;width:120px;height:auto;margin:0 auto 26px}',
    '.udp-h{font-size:44px;line-height:1.08;font-weight:800;margin:0 0 6px;color:' + INK + ';letter-spacing:-.01em}',
    '.udp-h.md{font-size:38px}',
    '.udp-sub{font-size:19px;margin:0 0 30px;color:' + INK + '}',
    '.udp-got{font-weight:800;line-height:1.05;margin:0 0 36px}',
    '.udp-got .l1{display:block;font-size:40px}',
    '.udp-got .l2{display:block;font-size:66px}',
    '.udp-got .l3{display:inline-block;font-size:66px;background:#2883FD;color:#fff;padding:0 6px}',
    '.udp-got.c .l3{font-size:56px;white-space:nowrap}',
    '.udp-btn{display:block;width:100%;max-width:300px;margin:0 auto;border:0;border-radius:6px;background:' + BLUE + ';color:#fff;font:700 20px/1.2 Montserrat,system-ui,sans-serif;padding:16px 18px;cursor:pointer;transition:transform .15s,background .15s;text-decoration:none}',
    '.udp-btn:hover{background:#2a3557;transform:translateY(-1px)}',
    '.udp-opts{max-width:540px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:12px}',
    '.udp-opts .udp-opt{margin:0}',
    '.udp-opt{display:block;width:100%;margin:0 0 14px;border:0;border-radius:6px;background:' + BLUE + ';color:#fff;font:700 19px/1.25 Montserrat,system-ui,sans-serif;padding:15px 16px;cursor:pointer;transition:background .15s,transform .15s}',
    '.udp-opt:hover{background:#2a3557;transform:translateY(-1px)}',
    '.udp-q{font-size:19px;margin:0 0 22px}',
    '.udp-timer{display:inline-block;background:' + BLUE + ';color:#fff;font-size:28px;font-weight:600;padding:14px 16px;border-radius:4px;margin:0 0 24px;font-variant-numeric:tabular-nums}',
    '.udp-link{display:inline-block;margin-top:10px;background:none;border:0;color:' + INK + ';text-decoration:underline;font:500 14px Montserrat,system-ui,sans-serif;cursor:pointer}',
    '.udp-form{max-width:300px;margin:0 auto}',
    '.udp-form input[type=email]{display:block;width:100%;border:1.5px solid #B9C0D0;border-radius:6px;padding:16px;font:500 18px Montserrat,system-ui,sans-serif;margin:0 0 12px;color:' + INK + ';background:#fff}',
    '.udp-form input[type=email]:focus{outline:none;border-color:' + BLUE + ';box-shadow:0 0 0 3px rgba(55,68,110,.15)}',
    '.udp-form input[type=tel]{display:block;width:100%;border:1.5px solid #B9C0D0;border-radius:6px;padding:16px;font:500 18px Montserrat,system-ui,sans-serif;margin:0 0 12px;color:' + INK + ';background:#fff}',
    '.udp-form input[type=tel]:focus{outline:none;border-color:' + BLUE + ';box-shadow:0 0 0 3px rgba(55,68,110,.15)}',
    '.udp-ok{display:flex;gap:10px;align-items:flex-start;text-align:left;font-size:11px;line-height:1.4;color:#5a6278;margin:0 0 14px;cursor:pointer}',
    '.udp-ok input{flex:0 0 auto;width:18px;height:18px;margin:1px 0 0;accent-color:' + BLUE + '}',
    '.udp-hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}',
    '.udp-err{color:#A9322F;font-size:14px;min-height:18px;margin:8px 0 0}',
    '.udp-legal{font-size:11px;color:#7A8296;margin:14px auto 0;max-width:320px;line-height:1.4}',
    '.udp-code{display:flex;align-items:center;justify-content:space-between;gap:10px;max-width:320px;margin:0 auto 16px;border:2px dashed ' + BLUE + ';border-radius:8px;padding:10px 10px 10px 18px}',
    '.udp-code b{font-size:26px;letter-spacing:.08em;color:' + BLUE + '}',
    '.udp-copy{border:0;background:#EEF1F8;color:' + BLUE + ';font:700 14px Montserrat,system-ui,sans-serif;padding:10px 14px;border-radius:6px;cursor:pointer}',
    '.udp-big{font-size:70px;font-weight:800;color:' + BLUE + ';line-height:1;margin:0 0 6px}',
    '.udp-p{font-size:16px;margin:0 0 14px;color:#4a5260}',
    '.udp-tease{position:fixed;left:0;top:50%;transform:translateY(-50%) rotate(180deg);writing-mode:vertical-rl;z-index:2147483000;background:' + BLUE + ';color:#fff;border:0;border-radius:0 8px 8px 0;font:800 14px Montserrat,system-ui,sans-serif;letter-spacing:.08em;padding:16px 10px;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.2)}',
    'html.mobile-nav-open .udp-tease,html.upside-cart-open .udp-tease{display:none}',
    '@media (max-width:767px){',
    '.udp{flex-direction:column;overflow-y:auto}',
    '.udp-right{order:-1;flex:0 0 200px;min-height:200px}',
    '.udp-right img{object-position:70% 40%}',
    '.udp-wave{top:auto;bottom:-1px;left:0;width:100%;height:46px}',
    '.udp-left{flex:1 0 auto;align-items:flex-start;padding:16px 20px 28px}',
    '.udp-x{top:212px;left:10px}',
    '.udp-logo{width:96px;margin-bottom:16px}',
    '.udp-h{font-size:32px}.udp-h.md{font-size:27px}',
    '.udp-sub{font-size:16px;margin-bottom:20px}',
    '.udp-got .l1{font-size:30px}.udp-got .l2,.udp-got .l3{font-size:46px}.udp-got.c .l3{font-size:38px}',
    '.udp-timer{font-size:22px;padding:10px 12px;margin-bottom:16px}',
    '.udp-opts{grid-template-columns:1fr;gap:10px;max-width:340px}',
    '.udp-opt{font-size:17px;padding:12px 14px}',
    '.udp-big{font-size:54px}',
    '.udp-tease{display:none}',
    '}'
  ].join('');

  // ---------- UI ----------
  var root = null, step = '', timerInt = null, answer = '';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function waveSvg() {
    return dev === 'm'
      ? '<svg class="udp-wave" viewBox="0 0 400 46" preserveAspectRatio="none" aria-hidden="true"><path d="M0 30 C120 0 230 46 400 14 L400 46 L0 46 Z" fill="#FDFDFD"/><path d="M0 30 C120 0 230 46 400 14" fill="none" stroke="' + BLUE + '" stroke-width="7"/></svg>'
      : '<svg class="udp-wave" viewBox="0 0 90 1000" preserveAspectRatio="none" aria-hidden="true"><path d="M0 0 L40 0 C-10 250 85 500 40 1000 L0 1000 Z" fill="#FDFDFD"/><path d="M40 0 C-10 250 85 500 40 1000" fill="none" stroke="' + BLUE + '" stroke-width="8"/></svg>';
  }
  function open() {
    if (root) return;
    if (!document.getElementById('udp-css')) {
      var st = document.createElement('style'); st.id = 'udp-css'; st.textContent = CSS; document.head.appendChild(st);
    }
    removeTeaser();
    root = document.createElement('div');
    root.className = 'udp';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<button class="udp-x" type="button" aria-label="' + T.close + '">&times;</button>' +
      '<div class="udp-left"><div class="udp-in"></div></div>' +
      '<div class="udp-right">' + (HERO ? '<img src="' + HERO + '" alt="">' : '') + waveSvg() + '</div>';
    document.body.appendChild(root);
    document.documentElement.style.overflow = 'hidden';
    root.querySelector('.udp-x').addEventListener('click', function () { close('x'); });
    document.addEventListener('keydown', onKey);
    track('show');
    if (textMode) showText(); else showGot();
  }
  function onKey(e) { if (e.key === 'Escape') close('esc'); }
  function close(how) {
    if (!root) return;
    if (step !== 'done') { track(how === 'nothanks' ? 'nothanks' : 'close', step); set('closed', String(Date.now())); }
    clearInterval(timerInt);
    root.remove(); root = null;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    flush();
    if (step !== 'done') showTeaser();
  }
  function body(html) {
    var b = root.querySelector('.udp-in');
    b.innerHTML = '<img class="udp-logo" src="' + LOGO + '" alt="Upside Drinks">' + html;
    // ignore taps for a moment so a fast scratch or double tap can't hit the next step's button
    b.style.pointerEvents = 'none';
    setTimeout(function () { b.style.pointerEvents = ''; }, 450);
    return b;
  }

  function showGot() {
    if (!root) return;
    step = 'claim';
    var got = variant === 'C'
      ? '<span class="l1">' + T.c1 + '</span><span class="l3">' + T.c2 + '</span><span class="l1" style="margin-top:6px">' + T.c3 + '</span>'
      : variant === 'B'
        ? '<span class="l1">' + T.m1 + '</span><span class="l2">' + T.m2 + '</span><span class="l3">' + T.m3 + '</span>'
        : '<span class="l1">' + T.got1 + '</span><span class="l2">' + T.got2 + '</span><span class="l3">' + T.got3 + '</span>';
    var b = body('<p class="udp-got' + (variant === 'C' ? ' c' : '') + '">' + got + '</p>' +
      '<button class="udp-btn" type="button">' + T.claim + '</button>');
    b.querySelector('.udp-btn').addEventListener('click', function () { track('claim'); showQuiz(); });
  }
  function showQuiz() {
    step = 'quiz';
    var head = '<div class="udp-timer">0:30</div><h2 class="udp-h md">' + ({ B: T.mLine, C: T.cLine }[variant] || T.gotLine) + '</h2>';
    var b = body(head + '<p class="udp-q">' + T.q + '</p><div class="udp-opts">' +
      T.a.map(function (a, i) { return '<button class="udp-opt" type="button" data-i="' + i + '">' + esc(a) + '</button>'; }).join('') +
      '</div><button class="udp-link" type="button">' + T.noThanks + '</button>');
    b.querySelectorAll('.udp-opt').forEach(function (btn) {
      btn.addEventListener('click', function () { answer = T.a[+btn.getAttribute('data-i')]; track('answer', answer); showEmail(); });
    });
    b.querySelector('.udp-link').addEventListener('click', function () { close('nothanks'); });
    var left = 30, el = b.querySelector('.udp-timer');
    clearInterval(timerInt);
    timerInt = setInterval(function () { left = Math.max(0, left - 1); el.textContent = '0:' + (left < 10 ? '0' : '') + left; if (!left) clearInterval(timerInt); }, 1000);
  }
  function showEmail() {
    clearInterval(timerInt);
    step = 'email';
    var b = body('<h2 class="udp-h md" style="margin-bottom:22px">' + ({ B: T.mWhere, C: T.cWhere }[variant] || T.where) + '</h2>' +
      '<form class="udp-form" novalidate><input type="email" name="email" autocomplete="email" placeholder="' + T.email + '" required>' +
      '<input class="udp-hp" type="text" name="website" tabindex="-1" autocomplete="off">' +
      '<button class="udp-btn" type="submit">' + T.reveal + '</button><p class="udp-err" aria-live="polite"></p></form>' +
      '<p class="udp-legal">' + T.legal + '</p>');
    var f = b.querySelector('form'), inp = f.querySelector('input[type=email]'), err = f.querySelector('.udp-err'), btn = f.querySelector('button');
    setTimeout(function () { try { inp.focus(); } catch (e) {} }, 50);
    inp.addEventListener('focus', function () { track('email_focus'); }, { once: true });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = inp.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = T.bad; return; }
      btn.disabled = true; btn.style.opacity = '.7'; err.textContent = '';
      fetch(API + '/subscribe', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, answer: answer, var: variant, lang: lang, vid: vid, dev: dev, path: path, website: f.website.value })
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (!j.ok) throw new Error(j.error || 'x');
        // Tie this browser to the email in Klaviyo (Alia did it): without it, Added to Cart / Checkout stay anonymous and abandoned cart flows never fire.
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); else (window._learnq = window._learnq || []).push(['identify', { $email: email }]); } catch (e) {}
        set('done', '1');
        if (j.prior === 'customer') { track('repeat_customer'); showBack(); }
        else if (j.prior === 'member') { track('repeat_member'); showDone(j.code || 'NEWUPSIDER', false, true); }
        else if (smsOn) showSms(email, j.code || 'NEWUPSIDER'); else showDone(j.code || 'NEWUPSIDER');
      }).catch(function () { btn.disabled = false; btn.style.opacity = ''; err.textContent = T.err; });
    });
  }
  function showSms(email, code) {
    step = 'done'; // email is already in: closing here is not an abandon
    track('sms_show');
    var b = body('<h2 class="udp-h md">' + T.smsH + '</h2><p class="udp-sub">' + T.smsP + '</p>' +
      '<form class="udp-form" novalidate><input type="tel" name="phone" autocomplete="tel" inputmode="tel" placeholder="' + T.phone + '" required>' +
      '<input class="udp-hp" type="text" name="website" tabindex="-1" autocomplete="off">' +
      '<label class="udp-ok"><input type="checkbox" name="ok"><span>' + T.smsOk + '</span></label>' +
      '<button class="udp-btn" type="submit">' + T.smsBtn + '</button><p class="udp-err" aria-live="polite"></p></form>' +
      '<button class="udp-link" type="button">' + T.noThanks + '</button>');
    var f = b.querySelector('form'), inp = f.querySelector('input[type=tel]'), err = f.querySelector('.udp-err'), btn = f.querySelector('button');
    b.querySelector('.udp-link').addEventListener('click', function () { track('sms_skip'); if (textMode) close('nothanks'); else showDone(code); });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = inp.value.replace(/\D/g, '');
      if (d.length === 11 && d[0] === '1') d = d.slice(1);
      if (d.length !== 10) { err.textContent = T.smsBadPhone; return; }
      if (!f.ok.checked) { err.textContent = T.smsNeedOk; return; }
      btn.disabled = true; btn.style.opacity = '.7'; err.textContent = '';
      fetch(API + '/sms', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, phone: d, consent: true, var: variant, lang: lang, vid: vid, website: f.website.value })
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (!j.ok) throw new Error(j.error || 'x');
        track('sms_submit');
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email, phone_number: '+1' + d }); } catch (e) {}
        if (textMode) showTextDone(); else showDone(code, true);
      }).catch(function () { btn.disabled = false; btn.style.opacity = ''; err.textContent = T.err; });
    });
  }
  // ---------- email campaign entry: ?udtext=1 ----------
  function klaEmail() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return '';
      var o = JSON.parse(atob(decodeURIComponent(m[1])));
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(o.$email || '') ? o.$email : '';
    } catch (e) { return ''; }
  }
  function showTextEmail() {
    step = 'done'; // nothing is subscribed by email here, closing is not an abandon
    var b = body('<h2 class="udp-h md">' + T.smsH + '</h2><p class="udp-sub">' + T.smsP + '</p>' +
      '<form class="udp-form" novalidate><input type="email" name="email" autocomplete="email" placeholder="' + T.email + '" required>' +
      '<button class="udp-btn" type="submit">' + T.next + '</button><p class="udp-err" aria-live="polite"></p></form>' +
      '<button class="udp-link" type="button">' + T.noThanks + '</button>');
    var f = b.querySelector('form'), inp = f.querySelector('input'), err = f.querySelector('.udp-err');
    setTimeout(function () { try { inp.focus(); } catch (e) {} }, 50);
    b.querySelector('.udp-link').addEventListener('click', function () { close('nothanks'); });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = inp.value.trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = T.bad; return; }
      showSms(email, '');
    });
  }
  function showTextDone() {
    step = 'done';
    var b = body('<h2 class="udp-h md">' + T.done + '</h2><p class="udp-p" style="font-weight:700;color:#37446E">' + T.smsSent + '</p>' +
      '<button class="udp-btn" type="button">' + T.shop + '</button>');
    b.querySelector('.udp-btn').addEventListener('click', function () { track('shop'); close('shop'); });
  }
  function showText() {
    var em = klaEmail();
    if (em) showSms(em, ''); else showTextEmail();
  }
  function showBack() {
    step = 'done';
    var b = body('<h2 class="udp-h md">' + T.backH + '</h2><p class="udp-p">' + T.backP + '</p><button class="udp-btn" type="button">' + T.backBtn + '</button>');
    b.querySelector('.udp-btn').addEventListener('click', function () { track('shop'); close('shop'); });
  }
  function showDone(code, smsDone, member) {
    step = 'done';
    // apply the code to the cart session right away (same as Alia's Shop now)
    try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
    var b = body('<h2 class="udp-h md">' + (member ? T.memberH : T.done) + '</h2><p class="udp-big">' + T.off.replace(' DE RABAIS', '') + '</p>' +
      '<p class="udp-p">' + (member ? T.memberP : T.applied) + '</p>' +
      '<div class="udp-code"><b>' + esc(code) + '</b><button class="udp-copy" type="button">' + T.copy + '</button></div>' +
      (smsDone ? '<p class="udp-p" style="font-weight:700;color:#37446E">' + T.smsSent + '</p>' : '') +
      '<button class="udp-btn" type="button">' + T.shop + '</button>');
    b.querySelector('.udp-copy').addEventListener('click', function () {
      var el = this; try { navigator.clipboard.writeText(code); } catch (e) {}
      el.textContent = T.copied; track('copy');
    });
    b.querySelector('.udp-btn').addEventListener('click', function () { track('shop'); close('shop'); });
  }

  // ---------- teaser (after a close) ----------
  var teaser = null;
  function showTeaser() {
    if (teaser || get('done') === '1') return;
    teaser = document.createElement('button');
    teaser.type = 'button'; teaser.className = 'udp-tease'; teaser.textContent = T.teaser;
    teaser.addEventListener('click', function () { track('teaser'); open(); });
    if (!document.getElementById('udp-css')) { var st = document.createElement('style'); st.id = 'udp-css'; st.textContent = CSS; document.head.appendChild(st); }
    document.body.appendChild(teaser);
  }
  function removeTeaser() { if (teaser) { teaser.remove(); teaser = null; } }

  // ---------- start ----------
  function start(cfg) {
    if (!cfg.live && !force) return;
    smsOn = !!cfg.sms || get('fsms') === '1';
    // while testing (or once live) keep Alia's popup out of the way
    var hide = document.createElement('style'); hide.textContent = '[id^="alia-root"]{display:none!important}'; document.head.appendChild(hide);
    if (textMode) { if (smsOn) setTimeout(open, 800); return; }
    if (!force && knownToKlaviyo()) return;
    var VARS = cfg.variants || ['A', 'B', 'C'];
    if (VARS.indexOf(variant) < 0 || get('round') !== String(cfg.round || 1)) {
      if (!(force && variant && VARS.indexOf(variant) >= 0)) variant = VARS[Math.floor(Math.random() * VARS.length)];
      set('var', variant); set('round', String(cfg.round || 1)); del('assigned');
    }
    if (!get('assigned')) { set('assigned', '1'); track('assign'); }
    var closedAt = Number(get('closed') || 0);
    if (!force && closedAt && Date.now() - closedAt < CLOSE_DAYS * 864e5) { showTeaser(); return; }
    setTimeout(open, 6000);
  }
  function boot() {
    fetch(API + '/config').then(function (r) { return r.json(); }).then(start).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
